import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import TemplatePopup from "../TemplatePopup";
import { useDispatch, useSelector } from "react-redux";
import {
  addAppTemplate, getAppTemplateAddedStatus, getAppTemplateSentStatus, getAppTemplateUpdatedStatus,
  getAppTemplates, loadAppTemplates, updateAppTemplate, getTemplateLoading, getTemplateSaveLoading
} from "../../app/store/template";
import { getAlert } from "../../services/appAlerts";
import ViewFormModal from "../../ReviewTools/ViewFormModal";

const TemplateLibrary = (props) => {
  const { workflowTask, setViewBprmFormShowHide, handleUpdateComponent } = props;

  const [selectedKey, setSelectedKey] = useState("home");
  const [selectedTempId, setSelectedTempId] = useState(0);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [viewFormShowHide, setViewFormShowHide] = useState(false);
  const [updateCompStatus, setUpdateCompStatus] = useState(false);

  const appTemplates = useSelector(getAppTemplates);
  const appTemplateAddedStatus = useSelector(getAppTemplateAddedStatus);
  const appTemplateUpdatedStatusSelector = useSelector(getAppTemplateUpdatedStatus);
  const appTemplateSentStatusSelector = useSelector(getAppTemplateSentStatus);
  const isLoading = useSelector((state) => state.entities.templates.loading || false);
  const isSaveLoading = useSelector(getTemplateSaveLoading);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (workflowTask?.ciid) {
      handleResetSelection();
      dispatch(loadAppTemplates(workflowTask.ciid));
      setUpdateCompStatus(true);
    }
  }, [dispatch, workflowTask?.ciid]);

  useEffect(() => {
    if (appTemplates.length > 0) {
      let tempItems = "";
      appTemplates.map((x, key) => {
        if (key > 0) tempItems += ",";
        tempItems += x.id;
        return x;
      });
      if (updateCompStatus) {
        handleUpdateComponent(tempItems);
        setUpdateCompStatus(false);
      }
    }
  }, [appTemplates, handleUpdateComponent, updateCompStatus]);

  useEffect(() => {
    if (appTemplateAddedStatus) {
      getAlert("", "Added Successfully", "success");
      if (workflowTask?.ciid) {
        dispatch(loadAppTemplates(workflowTask.ciid));
        setUpdateCompStatus(true);
      }

      setSelectedTempId(0);
      setSelectedTemplate(null);
      setSelectedKey("home");
    }
  }, [appTemplateAddedStatus, dispatch, workflowTask?.ciid]);

  useEffect(() => {
    if (appTemplateUpdatedStatusSelector) {
      getAlert("", "Updated Successfully", "success");
      if (workflowTask?.ciid) {
        dispatch(loadAppTemplates(workflowTask.ciid));
      }

      setSelectedTempId(0);
      setSelectedTemplate(null);
      setSelectedKey("home");
    }
  }, [appTemplateUpdatedStatusSelector, dispatch, workflowTask?.ciid]);

  useEffect(() => {
    if (appTemplateSentStatusSelector) {
      getAlert("", "Sent Successfully", "success");
      if (workflowTask?.ciid) {
        dispatch(loadAppTemplates(workflowTask.ciid));
      }
    }
  }, [appTemplateSentStatusSelector, dispatch, workflowTask?.ciid]);

  const handleSubmit = async (data) => {
    const frmData = new FormData();
    frmData.append("template", JSON.stringify(data));
    frmData.append("workflowTask", JSON.stringify(workflowTask));
    if (selectedTempId > 0) dispatch(updateAppTemplate(frmData));
    else dispatch(addAppTemplate(frmData));
  };

  const handleSelectTab = (tab) => {
    setSelectedKey(tab);
  };

  const handleResetSelection = () => {
    setSelectedTempId(0);
    setSelectedTemplate(null);
  };

  const handleSelectTemplate = (tmp) => {
    if (selectedTempId === tmp.id) {
      handleResetSelection();
    } else {
      const obj = { ...tmp, formId: tmp.templateId };
      setSelectedTemplate(obj);
      setSelectedTempId(tmp.id);
    }
  };

  const handlePrintTemplate = (item) => {
    navigate("/PrintTemplate", { state: { item: item } });
  };

  const handleViewFormShowHide = (tmp) => {
    if (tmp) {
      setViewFormShowHide(!viewFormShowHide);
      setViewBprmFormShowHide(!viewFormShowHide);
      const obj = { ...tmp, formId: tmp.templateId };
      setSelectedTemplate(obj);
    } else {
      setViewFormShowHide(!viewFormShowHide);
      setViewBprmFormShowHide(!viewFormShowHide);
    }
  };

  const renderSelectedTemplateCard = () => {
    if (selectedTempId === 0 || !selectedTemplate) return null;
    const isEmail = selectedTemplate.templateType?.toLowerCase().includes("email");
    const isLetter = selectedTemplate.templateType?.toLowerCase().includes("letter");
    const typeClass = isEmail ? "is-email" : isLetter ? "is-letter" : "is-default";

    return (
      <div className="rt-msg-selected-card">
        <div className="rt-msg-selected-info">
          <div className="rt-msg-selected-avatar">
            <i className="fa fa-files-o" aria-hidden="true" style={{ fontSize: "18px" }} />
          </div>
          <div className="rt-msg-selected-meta">
            <strong>{selectedTemplate.templateName || "Selected Template"}</strong>
            <span>
              Template ID #{selectedTemplate.id}
              <span>&bull;</span>
              <span className={`rt-template-type-badge ${typeClass}`}>
                {selectedTemplate.templateType || "Template"}
              </span>
            </span>
          </div>
        </div>
        <div className="rt-msg-selected-actions">
          <button
            className="btn-action-search"
            onClick={() => handleViewFormShowHide(selectedTemplate)}
            type="button"
          >
            <i className="fa fa-eye" aria-hidden="true" /> View
          </button>
          <button
            className="rt-template-action-btn is-download"
            onClick={() => handlePrintTemplate(selectedTemplate)}
            type="button"
          >
            <i className="fa fa-download" aria-hidden="true" /> Download
          </button>
          <button
            className="btn-action-search"
            onClick={() => handleSelectTab("profile")}
            type="button"
          >
            <i className="fa fa-pencil" aria-hidden="true" /> Edit
          </button>
          <button
            className="btn-action-search btn-danger-search"
            onClick={handleResetSelection}
            type="button"
            title="Clear selection"
            style={{ minWidth: "32px", padding: "7px 10px" }}
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="rt-template-tabs">
        <style>{`
          .rt-template-tabs {
            font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            background: transparent !important;
            color: #1e293b !important;
            --task-accent: #2563eb !important;
            --task-soft: #eff6ff !important;
            --primary-color: #2563eb;
            --primary-hover: #1d4ed8;
            --primary-soft: #eff6ff;
            --secondary-color: #64748b;
            --secondary-hover: #475569;
            --border-color: #e2e8f0;
            --bg-light: #f8fafc;
            --text-main: #1e293b;
            --text-muted: #64748b;
            position: relative;
          }

          @keyframes loadingBar {
            0%   { width: 0%; opacity: 1; }
            70%  { width: 85%; opacity: 1; }
            100% { width: 100%; opacity: 0; }
          }

          .wf-loading-bar {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            height: 3px !important;
            background: linear-gradient(90deg, #171717, #737373, #171717) !important;
            background-size: 200% 100% !important;
            animation: loadingBar 1.6s ease-in-out infinite !important;
            z-index: 10 !important;
          }

          @keyframes shimmer {
            0%   { background-position: -600px 0; }
            100% { background-position: 600px 0; }
          }

          .skeleton-cell {
            display: block;
            height: 13px;
            border-radius: 6px;
            background: linear-gradient(
              90deg,
              #f1f5f9 25%,
              #e2e8f0 50%,
              #f1f5f9 75%
            );
            background-size: 600px 100%;
            animation: shimmer 1.4s ease-in-out infinite;
          }

          .skeleton-cell.sk-short  { width: 40%; }
          .skeleton-cell.sk-medium { width: 65%; }
          .skeleton-cell.sk-long   { width: 85%; }
          .skeleton-cell.sk-full   { width: 92%; }

          .skeleton-row td {
            padding: 14px 16px !important;
          }

          @keyframes emptyFadeUp {
            from { opacity: 0; transform: translateY(18px); }
            to   { opacity: 1; transform: translateY(0); }
          }

          .wf-table-empty {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 56px 24px 48px;
            text-align: center;
            overflow: hidden;
            background: #ffffff;
            border-radius: 16px;
            margin: 12px;
            border: 1.5px solid rgba(37,99,235,0.08);
          }

          .wf-te-icon-wrap {
            position: relative;
            width: 80px; height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 24px;
            z-index: 1;
          }

          .wf-te-icon {
            width: 72px; height: 72px;
            border-radius: 16px;
            background: #f8fafc;
            border: 1.5px solid #e2e8f0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            color: #94a3b8;
            position: relative;
            z-index: 2;
          }

          .wf-te-title {
            font-size: 18px;
            font-weight: 500;
            color: #1e293b;
            margin: 0 0 10px 0;
            line-height: 1.3;
          }

          .wf-te-desc {
            font-size: 14px;
            font-weight: 400;
            color: #64748b;
            margin: 0 0 22px 0;
            line-height: 1.65;
          }

          .rt-msg-tab-bar {
            display: flex;
            align-items: stretch;
            gap: 4px;
            border-bottom: 2px solid #e5e5e5 !important;
            margin-bottom: 16px !important;
            padding: 8px 4px 0;
            position: relative;
          }

          .rt-msg-tab-btn {
            position: relative;
            display: inline-flex;
            align-items: center;
            gap: 7px;
            border: none;
            background: transparent;
            padding: 9px 16px 11px;
            font-size: 14px;
            font-weight: 500;
            color: #64748b;
            cursor: pointer;
            border-radius: 8px 8px 0 0;
            transition: color 0.2s ease, background 0.2s ease;
            outline: none;
            white-space: nowrap;
          }
          .rt-msg-tab-btn i {
            font-size: 13px;
            transition: color 0.2s ease;
          }
          .rt-msg-tab-btn:hover {
            color: #1e293b;
            background: rgba(37,99,235,0.04);
          }
          .rt-msg-tab-btn:focus,
          .rt-msg-tab-btn:focus-visible,
          .rt-msg-tab-btn:active {
            outline: none !important;
            box-shadow: none !important;
            border-color: transparent !important;
          }
          .rt-msg-tab-btn.active {
            color: var(--task-accent, #2563eb);
            font-weight: 500;
            background: var(--task-soft, rgba(37,99,235,0.06)) !important;
          }
          .rt-msg-tab-btn.active i {
            color: var(--task-accent, #2563eb);
          }
          .rt-msg-tab-btn::after {
            content: "";
            position: absolute;
            bottom: -2px;
            left: 0;
            right: 0;
            height: 2px;
            background: var(--task-accent, #2563eb);
            border-radius: 2px 2px 0 0;
            transform: scaleX(0);
            transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .rt-msg-tab-btn.active::after {
            transform: scaleX(1);
          }
          .rt-msg-tab-btn.tab-locked .rt-msg-tab-badge {
            background: rgba(245,158,11,0.1);
            color: #b45309;
            border-color: rgba(245,158,11,0.2);
          }
          .rt-msg-tab-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 20px;
            height: 20px;
            padding: 0 6px;
            border-radius: 999px;
            font-size: 12px;
            font-weight: 600;
            background: #f1f5f9;
            color: #64748b;
            border: 1px solid #e2e8f0;
            line-height: 1;
            transition: all 0.2s ease;
          }
          .rt-msg-tab-btn.active .rt-msg-tab-badge {
            background: var(--task-soft, rgba(37,99,235,0.1));
            color: var(--task-accent, #1d4ed8);
            border-color: var(--task-accent, rgba(37,99,235,0.2));
          }
          
          .rt-msg-panel {
            animation: rtMsgTabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
            flex: 1 1 auto !important;
            min-height: auto !important;
            overflow-y: visible !important;
            overflow-x: hidden !important;
            padding-top: 4px !important;
            padding-right: 4px !important;
          }
          .rt-msg-panel.is-form-panel,
          .rt-msg-panel.is-reply-panel {
            padding-top: 12px !important;
          }
          @keyframes rtMsgTabFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .rt-msg-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 8px !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            padding: 7px 14px !important;
            border-radius: 0 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #1e293b !important;
            box-shadow: 0 2px 5px rgba(15,23,42,0.08) !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            outline: none !important;
            white-space: nowrap !important;
            min-width: 120px !important;
          }
          .rt-msg-action-btn:hover {
            background: #f8fafc !important;
            color: #1e293b !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 2px 5px rgba(15,23,42,0.08) !important;
          }
          .rt-msg-action-btn.is-primary {
            background: var(--task-accent, #2563eb) !important;
            color: #ffffff !important;
            border-color: var(--task-accent, #2563eb) !important;
          }
          .rt-msg-action-btn.is-primary:hover {
            background: var(--task-accent, #2563eb) !important;
            color: #ffffff !important;
            transform: translateY(-1px) !important;
            opacity: 0.9 !important;
            box-shadow: 0 4px 10px -1px var(--task-accent, rgba(37, 99, 235, 0.25)) !important;
          }
          .rt-msg-action-btn.btn-danger-search {
            background: rgba(239, 68, 68, 0.06) !important;
            color: #dc2626 !important;
            border: 1px solid rgba(239, 68, 68, 0.18) !important;
          }
          .rt-msg-action-btn.btn-danger-search:hover {
            background: rgba(239, 68, 68, 0.12) !important;
            color: #b91c1c !important;
            border-color: rgba(239, 68, 68, 0.28) !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 8px -2px rgba(239, 68, 68, 0.12) !important;
          }

          .rt-msg-selected-card {
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 16px !important;
            padding: 12px 16px !important;
            margin: 0 0 16px 0 !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            background: #ffffff !important;
            box-shadow: none !important;
            flex-wrap: wrap !important;
            animation: rtMsgTabFadeIn 0.3s ease both !important;
          }
          .rt-msg-selected-info {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
          }
          .rt-msg-selected-avatar {
            width: 36px !important;
            height: 36px !important;
            border-radius: 0 !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            color: #1e293b !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            font-size: 15px !important;
            flex-shrink: 0 !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          }
          .rt-msg-selected-meta strong {
            display: block !important;
            color: #1e293b !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            margin-bottom: 3px !important;
          }
          .rt-msg-selected-meta span {
            color: #64748b !important;
            font-size: 14px !important;
            font-weight: 400 !important;
            display: flex !important;
            align-items: center !important;
            gap: 7px !important;
            flex-wrap: wrap !important;
          }
          .rt-msg-selected-actions {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            flex-wrap: wrap !important;
            flex-shrink: 0 !important;
          }
          
          .rt-msg-id-cell-span {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            color: #64748b !important;
            font-size: 13.5px !important;
            font-weight: 500 !important;
          }
          .rt-msg-row.selected-row .rt-msg-id-cell-span {
            color: #171717 !important;
            font-weight: 600 !important;
          }
          .rt-msg-id-cell-span .selected-icon {
            color: #2563eb !important;
            font-size: 13px !important;
          }

          .rt-template-type-badge {
            font-size: 11px !important;
            font-weight: 600 !important;
            text-transform: uppercase !important;
            padding: 2px 6px !important;
            border-radius: 0 !important;
            letter-spacing: 0.02em !important;
            display: inline-block !important;
          }
          .rt-template-type-badge.is-email {
            background: #eff6ff !important;
            color: #1e40af !important;
            border: 1px solid #bfdbfe !important;
          }
          .rt-template-type-badge.is-letter {
            background: #fdf2f8 !important;
            color: #9d174d !important;
            border: 1px solid #fbcfe8 !important;
          }
          .rt-template-type-badge.is-default {
            background: #f1f5f9 !important;
            color: #475569 !important;
            border: 1px solid #cbd5e1 !important;
          }

          .btn-action-search {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            background: transparent !important;
    border: none !important;
    padding: 0 !important;

    min-height: auto !important;
    height: auto !important;
            box-sizing: border-box !important;
            border-radius: 0 !important;
            font-family: inherit !important;
            font-size: 13.5px !important;
            font-weight: 500 !important;
            color: #2563eb !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            outline: none !important;
            box-shadow: none !important;
          }
          .btn-action-search:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            
            transform: translateY(-1px) !important;
          }
          .btn-action-search.btn-danger-search {
            background: transparent !important;
            border: none !important;
            box-shadow: none !important;
            color: #dc2626 !important;
            font-size: 16px !important;
          }
          .btn-action-search.btn-danger-search:hover {
            ackground: transparent !important;
            border: none !important;
            box-shadow: none !important;

            color: #b91c1c !important;
            transform: none !important;
          }
          .rt-msg-selected-actions .rt-msg-action-btn {
            height: 38px !important;
            box-sizing: border-box !important;
            justify-content: center !important;
          }
          .rt-msg-selected-actions .btn-danger-search {
            padding: 7px 14px !important;
            min-width: 38px !important;
          }

          .rt-template-toolbar {
            display: flex !important;
            justify-content: space-between !important;
            align-items: center !important;
            padding: 12px 18px !important;
            background: #f8fafc !important;
            border: 1.5px solid #edf2f7 !important;
            border-radius: 12px !important;
            margin-bottom: 12px !important;
          }
          .rt-template-toolbar-title {
            font-size: 12px !important;
            font-weight: 600 !important;
            color: #64748b !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 8px !important;
            text-transform: uppercase !important;
            letter-spacing: 0.04em !important;
          }
          .rt-template-toolbar-reset {
            background: transparent !important;
            border: none !important;
            color: var(--task-accent, #2563eb) !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            cursor: pointer !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            padding: 6px 12px !important;
            border-radius: 20px !important;
            transition: all 0.2s ease !important;
          }
          .rt-template-toolbar-reset:hover {
            background: var(--task-soft, #eff6ff) !important;
          }

          .table-responsive.rt-msg-table-scroll,
          .rt-msg-table-scroll {
            overflow: auto !important;
            max-height: 460px !important;
            border: none !important;
            border-radius: 0 !important;
            background: #ffffff !important;
            position: relative !important;
            box-shadow: none !important;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
            scrollbar-width: thin !important;
            scrollbar-color: #94a3b8 #f1f5f9 !important;
          }
          .rt-msg-table {
            width: 100%;
            margin-bottom: 0;
            border: none;
            border-collapse: separate;
            border-spacing: 0;
            color: #1e293b;
          }
          .rt-msg-table thead {
            position: sticky;
            top: 0;
            z-index: 2;
            background: #f8fafc;
          }
          .rt-msg-table thead tr th:first-child {
            border-top-left-radius: 0.375rem !important;
          }
          .rt-msg-table thead tr th:last-child {
            border-top-right-radius: 0.375rem !important;
          }
          .rt-msg-table thead th {
            color: #64748b;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 0.05em;
            text-transform: uppercase;
            padding: 12px 16px;
            border-top: none;
            border-bottom: 1.5px solid #edf2f7;
            white-space: nowrap;
          }
          .rt-msg-table td {
            padding: 14px 16px;
            font-size: 14px;
            font-weight: 400;
            color: #1e293b;
            vertical-align: top !important;
            border-top: none;
            border-bottom: 1.5px solid #edf2f7;
            background: transparent !important;
            transition: all 0.15s ease;
          }
          .rt-msg-table tbody tr:last-child td {
            border-bottom: none;
          }
          .rt-msg-table tbody tr.rt-msg-row {
            cursor: pointer;
            transition: transform 0.1s ease !important;
          }
          .rt-msg-table tbody tr.rt-msg-row:active {
            transform: scaleY(0.98) !important;
          }
          .rt-msg-table tbody tr.rt-msg-row:hover td {
            background-color: rgba(37, 99, 235, 0.04) !important;
            color: #1e293b !important;
          }
          .rt-msg-table tbody tr.rt-msg-row:hover td:first-child {
            box-shadow: inset 3px 0 0 0 #171717 !important;
          }
          .rt-msg-table tbody tr.rt-msg-row.selected-row td {
            background-color: #f1f5f9 !important;
            color: #0f172a !important;
            font-weight: 500 !important;
            border-bottom: 1px solid #f1f5f9 !important;
          }
          .rt-msg-table tbody tr.rt-msg-row.selected-row td:first-child {
            box-shadow: inset 4px 0 0 0 #171717 !important;
          }
          .rt-msg-table tbody tr.rt-msg-row.selected-row:hover td {
            background-color: rgba(37, 99, 235, 0.09) !important;
          }

          .wf-name-cell {
            display: flex !important;
            align-items: flex-start !important;
            gap: 10px !important;
            min-width: 190px !important;
          }
          .wf-name-avatar {
            width: 32px !important;
            height: 32px !important;
            border-radius: 0 !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            background: #f5f5f5 !important;
            border: 1px solid #d4d4d4 !important;
            color: #1e293b !important;
            font-size: 12px !important;
            font-weight: 500 !important;
            flex-shrink: 0 !important;
          }
          .wf-name-meta {
            display: flex !important;
            flex-direction: column !important;
            gap: 2px !important;
            min-width: 0 !important;
          }
          .wf-name-main {
            font-weight: 400 !important;
            color: #1e293b !important;
            font-size: 14px !important;
            line-height: 1.2 !important;
          }
          .wf-name-title {
            font-size: 14px !important;
            color: #64748b !important;
            font-weight: 400 !important;
            line-height: 1.2 !important;
          }
          .wf-empty-value {
            color: #64748b !important;
            font-size: 14px !important;
            font-weight: 400 !important;
            line-height: 1.2 !important;
          }

          .rt-msg-email {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            color: #64748b;
            font-size: 14px;
            font-weight: 400;
          }
          .rt-msg-email i {
            color: var(--task-accent, #2563eb);
          }
          .rt-msg-time {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            font-weight: 400;
            color: #64748b;
            white-space: nowrap;
          }
          .rt-msg-time-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            border-radius: 6px;
            background: #f8fafc;
            color: #64748b;
            font-size: 12px;
          }

          .rt-template-type-badge {
            font-size: 12px !important;
            font-weight: 600 !important;
            text-transform: uppercase !important;
            padding: 3px 8px !important;
            border-radius: 20px !important;
            letter-spacing: 0.04em !important;
            border: 1px solid transparent !important;
            display: inline-flex !important;
          }
          .rt-template-type-badge.is-email {
            background: #e0f2fe !important;
            color: #0369a1 !important;
            border-color: #bae6fd !important;
          }
          .rt-template-type-badge.is-letter {
            background: #fef3c7 !important;
            color: #b45309 !important;
            border-color: #fde68a !important;
          }
          .rt-template-type-badge.is-default {
            background: #f1f5f9 !important;
            color: #475569 !important;
            border-color: #e2e8f0 !important;
          }

          .rt-template-buttons-row {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
          }
          .rt-template-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 7px !important;
            background: transparent !important;
    border: none !important;
    padding: 0 !important;
            border-radius: 0 !important;
            font-family: inherit !important;
    font-size: 13.5px !important;
    font-weight: 500 !important;
    color: #2563eb !important;
            box-shadow: none !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            outline: none !important;
            white-space: nowrap !important;
           
          }
          .rt-template-action-btn:hover {
            background: #f8fafc !important;
            color: #1e293b !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1.5px) !important;
            box-shadow: 0 2px 5px rgba(15,23,42,0.08) !important;
          }
          .rt-template-action-btn.is-view {
            border-color: var(--task-accent, #2563eb) !important;
            color: var(--task-accent, #2563eb) !important;
          }
          .rt-template-action-btn.is-view:hover {
            background: var(--task-accent, #2563eb) !important;
            color: #ffffff !important;
            border-color: var(--task-accent, #2563eb) !important;
            box-shadow: 0 4px 10px -1px rgba(37, 99, 235, 0.25) !important;
          }
          .rt-template-action-btn.is-download {
            
            color: #10b981 !important;
          }
          .rt-template-action-btn.is-download:hover {
            
            
            box-shadow: none !important;
          }

          .rt-appointment-details-card {
            background: #ffffff;
            border: 1.5px solid var(--border-color, #e2e8f0);
            border-radius: 16px;
            padding: 28px;
            box-shadow: 0 4px 20px -2px rgba(0,0,0,0.02);
            display: flex;
            flex-direction: column;
            gap: 24px;
          }
          .details-section-title {
            font-size: 12px;
            font-weight: 600;
            color: var(--text-muted, #64748b);
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
          }
          .details-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
            gap: 16px;
          }
          .details-card {
            background: #ffffff;
            border: 1.5px solid #e2e8f0;
            border-radius: 12px;
            padding: 12px 18px;
            display: flex;
            align-items: center;
            gap: 14px;
            transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.01);
          }
          .details-card:hover {
            border-color: var(--primary-color, #2563eb);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
            transform: translateY(-1.5px);
          }
          .details-card-icon {
            width: 38px;
            height: 38px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            flex-shrink: 0;
          }
          .details-card-icon.icon-user { background: #eff6ff; color: #2563eb; }
          .details-card-icon.icon-email { background: #f5f3ff; color: #7c3aed; }
          .details-card-icon.icon-date { background: #ecfdf5; color: #059669; }
          .details-card-icon.icon-context { background: #fffbeb; color: #d97706; }
          
          .details-card-content {
            display: flex;
            flex-direction: column;
            gap: 2px;
            min-width: 0;
          }
          .details-card-label {
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            color: #64748b;
            letter-spacing: 0.03em;
          }
          .details-card-value {
            font-size: 14px;
            font-weight: 400;
            color: #1e293b;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .rt-schedule-remarks-enhanced {
            font-size: 14px !important;
            font-weight: 400 !important;
            color: #1e293b !important;
            line-height: 1.5 !important;
            background: #f8fafc !important;
            padding: 16px 20px !important;
            border-radius: 12px !important;
            border-left: 4px solid var(--task-accent, #2563eb) !important;
            display: flex !important;
            gap: 12px !important;
            align-items: flex-start !important;
          }
          .rt-schedule-remarks-icon {
            color: #94a3b8;
            font-size: 16px;
            margin-top: 2px;
          }

          .rt-msg-empty-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 220px;
            padding: 36px 20px;
            text-align: center;
            background: #ffffff;
            border-radius: 12px;
          }
          .rt-msg-empty-icon {
            width: 48px;
            height: 48px;
            border-radius: 12px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: var(--task-soft, #eff6ff);
            color: var(--task-accent, #2563eb);
            font-size: 20px;
            margin-bottom: 16px;
          }
          .rt-msg-empty-title { margin: 0; color: #1e293b; font-size: 14px; font-weight: 500; }
          .rt-msg-empty-desc { margin: 6px 0 0; color: #64748b; font-size: 14px; font-weight: 400; }
        `}</style>

        <div className="rt-msg-tab-bar">
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "home" ? " active" : ""}`}
            onClick={() => handleSelectTab("home")}
          >
            <i className="fa fa-files-o" aria-hidden="true" />
            Templates
            <span className="rt-msg-tab-badge">{appTemplates.length}</span>
          </button>
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "profile" ? " active" : ""}`}
            onClick={() => handleSelectTab("profile")}
          >
            <i className={`fa ${selectedTempId > 0 ? "fa-pencil" : "fa-plus-circle"}`} aria-hidden="true" />
            {selectedTempId > 0 ? "Edit" : "Add"} Template
          </button>
        </div>

        <div className="rt-msg-panel-content">
          {selectedKey === "home" && (
            <div className="rt-msg-panel">
              {renderSelectedTemplateCard()}

              <div className="table-responsive rt-msg-table-scroll">
                <table className="table align-items-center table-flush rt-msg-table">
                  <thead>
                    {isLoading && (
                      <tr style={{ height: "0px", padding: 0 }}>
                        <th colSpan={5} style={{ padding: 0, border: "none", height: "0px", position: "relative" }}>
                          <div className="wf-loading-bar" />
                        </th>
                      </tr>
                    )}
                    <tr>
                      <th style={{ width: "80px" }}>ID</th>
                      <th>Created</th>
                      <th>Sender</th>
                      <th>Name / Type</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      Array.from({ length: 5 }).map((_, i) => (
                        <tr key={`skel-${i}`} className="skeleton-row">
                          <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                          <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                          <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                          <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                          <td style={{ textAlign: "right" }}><span className="skeleton-cell sk-medium" style={{ marginLeft: "auto", animationDelay: `${i * 0.06}s` }} /></td>
                        </tr>
                      ))
                    ) : appTemplates.length === 0 ? (
                      <tr>
                        <td colSpan={5} style={{ padding: 0 }}>
                          <div className="wf-table-empty">
                            <div className="wf-te-icon-wrap">
                              <div className="wf-te-icon">
                                <i className="fa fa-files-o" />
                              </div>
                            </div>
                            <h3 className="wf-te-title">No Templates Found</h3>
                            <p className="wf-te-desc">
                              There are currently no templates in the library for this workflow task.
                              You can add a new template using the button below.
                            </p>
                            <button
                              className="rt-msg-action-btn is-primary"
                              type="button"
                              onClick={() => handleSelectTab("profile")}
                              style={{ marginTop: "4px" }}
                            >
                              <i className="fa fa-plus-circle" aria-hidden="true" /> Add New Template
                            </button>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      appTemplates.map((item, idx) => {
                        const isSelected = selectedTempId === item.id;
                        const isEmail = item.templateType?.toLowerCase().includes("email");
                        const isLetter = item.templateType?.toLowerCase().includes("letter");
                        const typeClass = isEmail ? "is-email" : isLetter ? "is-letter" : "is-default";

                        return (
                          <tr
                            key={item.id}
                            className={`rt-msg-row ${isSelected ? "selected-row" : ""}`}
                            onClick={() => handleSelectTemplate(item)}
                            style={{ animationDelay: `${idx * 0.04}s` }}
                            title={isSelected ? `Click to deselect: Template #${item.id}` : `Click to select: Template #${item.id}`}
                          >
                            <td>
                              <span className="rt-msg-id-cell-span">
                                {isSelected && (
                                  <i className="fa fa-check-circle selected-icon" />
                                )}
                                #{item.id}
                              </span>
                            </td>
                            <td>
                              <div className="rt-msg-time" style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                <span style={{ color: "#1e293b", fontWeight: 500, fontSize: "13.5px" }}>
                                  <Moment format="MMM D, YYYY">{item.addedDatetime}</Moment>
                                </span>
                                <span style={{ color: "#64748b", fontSize: "12px" }}>
                                  <Moment format="h:mm a">{item.addedDatetime}</Moment>
                                </span>
                              </div>
                            </td>
                            <td>
                              <div className="wf-name-cell">
                                <span className="wf-name-avatar">
                                  {(item.performer || "?").split(/\s+/).filter(Boolean).map((n) => n[0]).join("").slice(0, 2).toUpperCase()}
                                </span>
                                <div className="wf-name-meta">
                                  <span className="wf-name-main">{item.performer || "System"}</span>
                                  <span className="wf-name-title">
                                    {[item.role, item.department, item.partner].filter(Boolean).join(" - ") || "No Context"}
                                  </span>
                                  {item.email && (
                                    <span className="rt-msg-email" style={{ marginTop: "2px" }} title={item.email}>
                                      {item.email}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "6px" }}>
                                <span style={{ fontWeight: 500, color: "#1e293b", fontSize: "14px" }}>
                                  {item.templateName}
                                </span>
                                <span className={`rt-template-type-badge ${typeClass}`}>
                                  {item.templateType}
                                </span>
                              </div>
                            </td>
                            <td style={{ textAlign: "left" }}>
                              <div className="rt-template-buttons-row" onClick={(e) => e.stopPropagation()}>
                                <button
                                  type="button"
                                  className="btn-action-search"
                                  onClick={() => handleViewFormShowHide(item)}
                                >
                                  <i className="fa fa-eye" aria-hidden="true" /> View
                                </button>
                                <button
                                  type="button"
                                  className="rt-template-action-btn is-download"
                                  onClick={() => handlePrintTemplate(item)}
                                >
                                  <i className="fa fa-download" aria-hidden="true" /> Download
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}


          {selectedKey === "profile" && (
            <div className="rt-msg-panel is-form-panel">
              <TemplatePopup
                selectedTemplate={selectedTemplate}
                handleSubmit={handleSubmit}
                onClose={() => handleSelectTab("home")}
                isLoading={isSaveLoading}
              />
            </div>
          )}
        </div>
      </div>
      <ViewFormModal
        viewFormShowHide={viewFormShowHide}
        handleViewForm={handleViewFormShowHide}
        workflowTask={workflowTask}
        selectedForm={selectedTemplate}
      />
    </React.Fragment>
  );
};

export default TemplateLibrary;
